import { useAuth0 } from '@auth0/auth0-react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  useGetListItems,
  useGetItemById,
  useMutateItem,
} from '../../../hooks/entityMethodsHook'
import Api from '../../../lib/api'
import { getCurrentDateTime } from '../../../lib/time'
import { getStartDateTime, getEndDateTime } from '../../../lib/workTime'

export const useGetTimeSheets = (
  queryKey: string,
  projectId: string | undefined,
  queryOptions: any
) => {
  let uri = `timecards/project/${projectId}`

  if (queryOptions && queryOptions.recordStatusFilter) {
    // Used to filter the timesheets for kiosk to show only records that do not have a clock-out
    uri += `?status=${encodeURIComponent(queryOptions.recordStatusFilter)}`
  }
  // return useGetPaginatedListItems(queryKey, uri, queryOptions)
  return useGetListItems(queryKey, uri)
}

export const useGetTimeSheetsByDate = (
  queryKey: string,
  projectId: string | undefined,
  queryOptions: any
) => {
  const date = queryOptions.date || getCurrentDateTime()
  const startDate = getStartDateTime(date)
  const endDate = getEndDateTime(date)
  const timesheetType = queryOptions.timesheetType || 'default'

  // url encode dates.
  const urlEncodedStartDate = encodeURIComponent(startDate)
  const urlEncodedEndDate = encodeURIComponent(endDate)
  const uri = `timecards/project/${projectId}?startDate=${urlEncodedStartDate}&endDate=${urlEncodedEndDate}&type=${timesheetType}`
  return useGetListItems(queryKey, uri)
}

export const useGetTimeSheetById = (key: string, id: string | undefined) => {
  const uri = `users/timesheets/${id}`
  return useGetItemById(key, uri, id)
}

export const useGetTimeSheetByWorkerId = (
  key: string,
  id: string | undefined
) => {
  const uri = `users/timesheets/worker/${id}`
  return useGetItemById(key, uri, id)
}

export const useMutateTimesheet = (key: string) => {
  const uri = 'users/timesheets'
  return useMutateItem(key, uri)
}

export const useMutateUpdateTimeSheet = (
  key: string,
  timesheetId: string | undefined
) => {
  const uri = `users/timesheets`
  return useMutateItem(key, uri)
}

export const useMutateFinalizeTimeSheets = (
  key: string,
  timesheets: string[]
) => {
  const uri = 'users/timesheets/finalize'
  return useMutateItem(key, uri)
}

export const useFinalizeTimesheets = (
  key: string,
  endpoint: string | undefined
) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    async (timesheetIds: string[]) => {
      const token = await getAccessTokenSilently()
      return await Api.post(`v1/${endpoint}`, timesheetIds, token)
    },
    {
      onSuccess: () => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({ queryKey: ['projectTimesheets'] }),
        ])
      },
    }
  )
  return mutation
}
